// Both PHOTO_SQURE and PHOTO_HEXAGON have an id of '287667'
export const YOUR_IMAGE_HERE_IDS = [
  '226353',
  '235941',
  '287667',
  '367547',
  '367548',
  '367549'
];
